import React, { useCallback, useContext, useState } from "react";
import { INIT_FILTER_STATE } from "../../../../constants/driveglobalfilterinitalstates";
import FilterSecondPageErc from "./FilterSecondPageErc";
import TopkpisSecondErc from "./TopkpisSecondErc";
import TopkpisSecondMainErc from "./TopkpisSecondMainErc";
import WaterMark from "../../DashboardMain/WaterMark";
import TableMainErc from "./TableMainErc";
import RangeSecondErc from "./RangeSecondErc";
import NetEnergySecondErc from "./NetEnergySecondErc";
import SocDisErc from "./SocDisErc";
import DischargeDurErc from "./DischargeDurErc";
import CycleVsRange from "./CycleVsRange";
import BmsCellTemp from "./BmsCellTemp";
import BmsDeltaCellVolt from "./BmsDeltaCellVolt";
import McuContTemp from "./McuContTemp";
import MotorTempErc from "./MotorTempErc";
import DcdcTemp from "./DcdcTemp";

function PageSecondErc(props) {
  const [secondPageState, setSecondPageState] = useState({
    startDate: props.gloablfilter.startDate,
    endDate: props.gloablfilter.endDate,
    vin_num: props.gloablfilter.VIN_NUM.toString().toUpperCase(),
    soc_per: props.gloablfilter.soc_per,
  });


  const filterSubmited = useCallback((data) => {
    setSecondPageState(data);
  }, []);

  const pageChange = useCallback((data) => {
    props.pageChange();
  }, []);

  return (
    <>
      <FilterSecondPageErc
        onsubmit={filterSubmited}
        pageChange={pageChange}
        secondPageState={secondPageState}
      />
      <div className="container-fluid">
        <TopkpisSecondErc
          gloablfilter={secondPageState}
          apiend="drivesecondpage_erc/topkpis_erc"
        />
        <TopkpisSecondMainErc
          gloablfilter={secondPageState}
          apiend="drivesecondpage_erc/topkpismain_erc"
        />
        <section className="graphs">
          <div className="row">
            <div className="col-md-6 col-sm-12 col-lg-3 pr-1 drive_graph">
              <WaterMark />
              <TableMainErc
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/table_erc"
              ></TableMainErc>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <RangeSecondErc
                title="Real World Range Distribution"
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/bar_chart_erc"
              ></RangeSecondErc>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <NetEnergySecondErc
                title="Net Energy Consumption"
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/bar_chart_erc"
              ></NetEnergySecondErc>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-2">
              <WaterMark />
              <SocDisErc
                title="SoC Discharge/Cycle Analysis"
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/bar_chart_erc"
              ></SocDisErc>
            </div>
          </div>

          <div className="row mt-2 pt-2">
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <DischargeDurErc
                title="Median Discharge Duration"
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/bar_chart_erc"
              ></DischargeDurErc>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <CycleVsRange
                title="Discharge Cycle Vs Range"
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/cycle_vs_range_erc"
              ></CycleVsRange>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <BmsCellTemp
                title="BMS Cell Temperature"
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/bms_cell_temp_erc"
              ></BmsCellTemp>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-2">
              <WaterMark />
              <BmsDeltaCellVolt
                title="BMS Delta Cell Voltage"
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/bms_delta_temp_erc"
              ></BmsDeltaCellVolt>
            </div>
          </div>

          <div className="row mt-2 pt-1">
            <div className="col-md-6 col-sm-12 col-lg-4 drive_graph pr-0">
              <WaterMark />
              <McuContTemp
                title="MCU Controller Temperature"
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/mcu_temp_erc"
              ></McuContTemp>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-4 drive_graph pr-0">
              <WaterMark />
              <MotorTempErc
                title="Motor Temperature"
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/motor_temp_erc"
              ></MotorTempErc>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-4 drive_graph pr-1">
              <WaterMark />
              <DcdcTemp
                title="DCDC Temperature"
                gloablfilter={secondPageState}
                apiend="drivesecondpage_erc/dcdc_temp_erc"
              ></DcdcTemp>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default PageSecondErc;
